import { compose } from 'redux';
import actionTypes from './actionTypes';
import { serializeProduct } from '../serializers';

const initialState = {
    listing:{
        isLoading: false,
        areProductsLoaded: false,
        productsList: [],
        error: undefined,
    }
};

export default (state = initialState, action) => {
    switch(action.type){
    case actionTypes.LOAD_PRODUCTS_START:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: true
            },
        };
    case actionTypes.LOAD_PRODUCTS_SUCCESS:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: false, 
                areProductsLoaded: true,
                productsList: action.payload.data.map(serializeProduct),
            },
        };
    case actionTypes.LOAD_PRODUCTS_FAIL:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: false,
                error: action.payload.error
            },
        };
    default: 
        return state;
    }
};